export default "__VITE_ASSET__CMVhNGz___"